export const getMasterGuideTabOrder = (settings = {}) => {
  const orderedTypes = (settings.guestbook?.tab_order || "")
    .split(",")
    .filter(Boolean);
  const fallbackTypes = [
    ...(settings.welcome_order || []).map((item) => item?.type),
    ...(settings.welcome_tabs || []).map((item) => item?.type),
  ].filter(Boolean);

  return [...new Set([...orderedTypes, ...fallbackTypes])];
};

export const getMasterGuideTabLabel = (tab) =>
  tab?.type === "arrival" ? "Your Stay" : tab?.label || "";

export const getMasterGuideTabMove = (tabOrder, oldIndex, newIndex) => {
  const targetIndex = Math.max(1, newIndex);

  if (
    oldIndex < 1 ||
    oldIndex >= tabOrder.length ||
    targetIndex >= tabOrder.length ||
    oldIndex === targetIndex
  ) {
    return null;
  }

  return { oldIndex, newIndex: targetIndex };
};

export const getInitialMasterGuideTabType = ({
  embedded = false,
  focusedTabType = "",
  preferredTabType = "",
  firstTabType = "",
}) =>
  focusedTabType || (!embedded ? preferredTabType : "") || firstTabType;

export const removeMasterGuideTab = (settings, tabType) => {
  const remainingTabOrder = getMasterGuideTabOrder(settings).filter(
    (type) => type !== tabType,
  );

  return {
    guestbook: {
      ...settings.guestbook,
      tab_order: remainingTabOrder.join(","),
    },
    welcome_tabs: (settings.welcome_tabs || []).filter(
      (tab) => tab.type !== tabType,
    ),
    welcome_order: (settings.welcome_order || []).filter(
      (order) => order.type !== tabType,
    ),
  };
};
